var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('VHeader'),_vm._v("\n    signing in...\n    \n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }